<nz-spin [nzSpinning]="true" nzSize="large">

</nz-spin>